import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchCRTModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchCRTModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchCRTModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchCRTModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchCRTModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
